<template>
  <header>
    <!-- <div class="container"> -->
    <base-container>
      <el-row justify="space-around">
        <el-col :span="9">
          <el-menu mode="horizontal" :ellipsis="false">
            <el-menu-item index="1">日本雅虎拍賣</el-menu-item>
            <el-menu-item index="2">日本樂天購物</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="14">
          <el-menu mode="horizontal" :ellipsis="false">
            <el-sub-menu index="3">
              <template #title>
                <img
                  src="../../assets/icon-lang@2x.png"
                  style="width: 20px; margin-right: 0.3rem"
                  alt=""
                />繁體中文</template
              >
              <el-menu-item index="2-1">item one</el-menu-item>
              <el-menu-item index="2-2">item two</el-menu-item>
              <el-menu-item index="2-3">item three</el-menu-item>
            </el-sub-menu>
            <el-menu-item index="4">通告版</el-menu-item>
            <el-menu-item index="5">費用試算</el-menu-item>
            <el-menu-item index="6">每日匯率</el-menu-item>
            <el-menu-item index="7" class="auth">登入 / 註冊賬號</el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </base-container>
    <!-- </div> -->
    <hr />

    <!-- <div class="container"> -->
    <base-container>
      <!-- Bottom Navbar -->
      <el-row class="bottom-navbar" justify="space-between" :gutter="90">
        <el-col :span="5">
          <img
            src="../../assets/logo@2x.png"
            @click="$router.push('/main')"
            class="logo"
            alt=""
          />
        </el-col>
        <el-col :span="13">
          <el-menu :ellipsis="false" mode="horizontal" class="right-section">
            <el-menu-item index="1">關於我們</el-menu-item>
            <el-menu-item index="2">購物資訊</el-menu-item>
            <el-menu-item index="3">服務收費</el-menu-item>
            <el-menu-item index="4">折扣優惠</el-menu-item>
            <el-menu-item index="5">聯絡我們</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="5">
          <el-button
            :icon="Edit"
            size="large"
            class="my-navbar-button"
            type="primary"
            >填寫訂單</el-button
          >
        </el-col>
      </el-row>
    </base-container>
    <!-- </div> -->
  </header>
</template>

<script>
import { Edit } from "@element-plus/icons-vue";

export default {
  data() {
    return {
      activeIndex: "1",
      Edit: Edit,
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
header {
  background-color: #fff;
  min-width: 990px;
  /* box-shadow: 0px 4px 10px red; */
  box-shadow: 0px 4px 10px rgba(68, 13, 80, 0.1);
  position: relative;
  z-index: 1;
}

header .el-row:first-of-type {
  /* width: 100%; */
}

hr {
  margin: 0;
}

.bottom-navbar {
  align-items: center;
}

.my-navbar-button {
  /* margin-left: 3rem; */
  border-radius: 12px;
  background-color: #7a3d87;
  border-color: #7a3d87;
  /* margin: 0 5rem; */
}

.logo {
  width: 100px;
  cursor: pointer;
  /* text-align: left; */
  /* margin-top: 1rem; */
}

.el-menu--horizontal {
  border-bottom: none;
}

.container {
  padding: 0 13rem;
}

.el-menu-item.auth {
  color: #7a3d87;
  font-weight: 700;
}
</style>